import React, { useEffect, useState } from "react";

function CharacterSkills({
  character,
  handleDiceRoll,
  editMode,
  handleSaveCharacter,
}) {
  const [skills, setSkills] = useState(
    [...character.skills].sort((a, b) => a.name.localeCompare(b.name)),
  );
  const [baseSkillNames, setBaseSkillNames] = useState([]);

  useEffect(() => {
    // Carica la lista delle skills base dal localStorage
    const listSkills = JSON.parse(localStorage.getItem("listSkills") || "[]");
    // Salva i nomi esatti delle skill base
    const baseNames = listSkills.map((skill) => skill.name);
    setBaseSkillNames(baseNames);
  }, []);

  useEffect(() => {
    if (!editMode) {
      setSkills(
        [...character.skills].sort((a, b) => a.name.localeCompare(b.name)),
      );
    }
  }, [editMode, character]);

  // Normalizza il nome della skill: forza minuscolo tra parentesi
  // e preserva la parte base della skill
  const normalizeSkillName = (newName) => {
    // Se il nome contiene parentesi, forza minuscolo solo la parte tra parentesi
    const match = newName.match(/^(.+?)\s*\((.+?)\)$/);
    if (match) {
      const basePart = match[1].trim();
      const specialization = match[2].toLowerCase();
      return `${basePart} (${specialization})`;
    }
    return newName;
  };

  // Verifica se una skill è cancellabile (non è presente in listSkills)
  const isSkillDeletable = (skillName) => {
    // Se la skill è presente esattamente in baseSkillNames, NON è cancellabile
    if (baseSkillNames.includes(skillName)) {
      return false;
    }

    // Se la skill ha una specializzazione (contiene parentesi)
    const match = skillName.match(/^(.+?)\s*\((.+?)\)$/);
    if (match) {
      const basePart = match[1].trim();
      const specialization = match[2].trim().toLowerCase();

      // Controlla se esiste una versione "(generico)" di questa skill in baseSkillNames
      const genericVersion = `${basePart} (generico)`;
      if (baseSkillNames.includes(genericVersion)) {
        // Se esiste la versione generica e questa NON è la generica, è cancellabile
        return specialization !== "generico";
      }

      // Altrimenti, se il nome esatto è in baseSkillNames, non è cancellabile
      return !baseSkillNames.includes(skillName);
    }

    // Skill senza parentesi: cancellabile solo se non è in baseSkillNames
    return true;
  };

  const refreshListSkills = () => {
    const updatedSkills = [...skills];
    character.skills.forEach((s) => {
      const index = skills.findIndex((skill) => skill.name === s.name);
      if (index === -1) {
        updatedSkills.push(s);
      }
    });
    setSkills(
      updatedSkills.sort((a, b) => {
        if (a.name < b.name) {
          return -1;
        }
        if (a.name > b.name) {
          return 1;
        }
        return 0;
      }),
    );
  };

  const handleUpdateSkill = (index, skill, shouldNormalize = false) => {
    const updatedSkills = [...skills];

    // Se shouldNormalize è true (onBlur), normalizza il nome
    if (shouldNormalize && skill.name) {
      skill.name = normalizeSkillName(skill.name);
    }

    updatedSkills[index] = skill;
    setSkills(updatedSkills.sort((a, b) => a.name.localeCompare(b.name)));
  };

  return (
    <div className="character-sheetpage_skills">
      {skills.map((s, index) => (
        <div
          key={`skills_${index}`}
          className="character-sheetpage_skills_stat character-hover"
          onClick={() => (editMode ? null : handleDiceRoll(s.name, s.value))}
        >
          <div className="sheetpage_skills_stat_name">
            {editMode ? (
              s.isSpecializable ? (
                <input
                  type="text"
                  value={s.name}
                  onChange={(e) =>
                    handleUpdateSkill(
                      index,
                      { ...s, name: e.target.value },
                      false,
                    )
                  }
                  onBlur={() => {
                    handleUpdateSkill(index, skills[index], true);
                    refreshListSkills();
                  }}
                />
              ) : (
                <input type="text" value={s.name} readOnly />
              )
            ) : (
              <span>{s.name}</span>
            )}
          </div>
          <div className="sheetpage_skills_stat_value">
            {editMode ? (
              <input
                type="text"
                value={s.value}
                onChange={(e) =>
                  handleUpdateSkill(index, { ...s, value: e.target.value })
                }
              />
            ) : (
              <span>{s.value}</span>
            )}
          </div>
          {editMode && isSkillDeletable(s.name) && (
            <div className="sheetpage_skills_stat_delete">
              <button
                onClick={() => {
                  if (
                    window.confirm("Sei sicuro di voler cancellare la skill?")
                  ) {
                    const updatedSkills = [...skills];
                    updatedSkills.splice(index, 1);
                    setSkills(updatedSkills);
                  }
                }}
                title="Elimina abilità specializzata"
              >
                ✕
              </button>
            </div>
          )}
        </div>
      ))}
      {editMode && (
        <button
          onClick={() => {
            // Normalizza tutte le skills prima di salvare
            const normalizedSkills = skills.map((skill) => ({
              ...skill,
              name: normalizeSkillName(skill.name, skill.name),
            }));
            handleSaveCharacter({ ...character, skills: normalizedSkills });
          }}
        >
          Save
        </button>
      )}
    </div>
  );
}

export default CharacterSkills;
